var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenchmarksMarketShareEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "benchmarks_market_share_empty_state_svg__a",
    d: "M136.993 167.45c0-2.127 3.464-2.934 3.464-5.928 0-2.482-2.126-3.782-4.31-3.782-2.008 0-3.818.985-4.566 2.915l1.948 1.103c.394-1.162 1.319-1.812 2.559-1.812 1.26 0 2.105.571 2.105 1.714 0 2.147-3.463 2.895-3.463 5.79h2.263zm-1.122 4.57c.807 0 1.476-.67 1.476-1.477 0-.827-.669-1.477-1.476-1.477-.827 0-1.476.65-1.476 1.477 0 .808.65 1.477 1.476 1.477zm16.788-4.57c0-2.127 3.464-2.934 3.464-5.928 0-2.482-2.126-3.782-4.31-3.782-2.008 0-3.818.985-4.566 2.915l1.948 1.103c.394-1.162 1.319-1.812 2.559-1.812 1.26 0 2.106.571 2.106 1.714 0 2.147-3.464 2.895-3.464 5.79h2.263zm-1.122 4.57c.807 0 1.476-.67 1.476-1.477 0-.827-.669-1.477-1.476-1.477-.826 0-1.476.65-1.476 1.477 0 .808.65 1.477 1.476 1.477zm16.788-4.57c0-2.127 3.464-2.934 3.464-5.928 0-2.482-2.126-3.782-4.31-3.782-2.008 0-3.818.985-4.566 2.915l1.948 1.103c.394-1.162 1.319-1.812 2.559-1.812 1.26 0 2.106.571 2.106 1.714 0 2.147-3.464 2.895-3.464 5.79h2.263zm-1.122 4.57c.807 0 1.476-.67 1.476-1.477 0-.827-.669-1.477-1.476-1.477-.826 0-1.476.65-1.476 1.477 0 .808.65 1.477 1.476 1.477z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M54.053 10.613L31.898 45.7a4.96 4.96 0 01-8.43 0L1.322 10.613a5.078 5.078 0 01-.191-5.144 5.068 5.068 0 014.401-2.663h44.306a5.067 5.067 0 014.405 2.66 5.079 5.079 0 01-.19 5.147zm118.145-1.057l-22.155 35.082a4.958 4.958 0 01-8.43 0L119.458 9.556a5.076 5.076 0 01-.187-5.142 5.066 5.066 0 014.402-2.66h44.306a5.069 5.069 0 014.405 2.657 5.075 5.075 0 01-.186 5.145zm118.582 0l-22.15 35.082a4.958 4.958 0 01-8.43 0L238.05 9.556a5.075 5.075 0 01-.188-5.14 5.067 5.067 0 014.398-2.662h44.305a5.074 5.074 0 014.215 7.802z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.932,
    cy: 98.97,
    fill: "#CCC",
    rx: 20.226,
    ry: 20.243
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.704,
    cy: 100.057,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 18.689,
    ry: 18.705
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4C5363",
    strokeDasharray: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M129.281 100.216H85.664m89.088 0h13.046M45.896 84.45a48.027 48.027 0 01-12.53-32.423h0m42.222 47.827a50.486 50.486 0 01-1.889-.268 47.957 47.957 0 01-20.935-8.899m217.18-28.595a48.492 48.492 0 001.051-10.065h0m-64.765 48.189h16.621c19.297.006 36.733-11.517 44.306-29.28m-72.084 29.28h3.967m-46.86-38.462V51.159m0 27.31v-8.218m-.496 80.168v-29.29",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M203.31 101.596a2.103 2.103 0 00.12-2.64 2.098 2.098 0 00-3.737 1.696 2.096 2.096 0 003.616.944"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4FF6",
    fillRule: "nonzero",
    stroke: "#4C4FF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M82.317 101.596a2.1 2.1 0 00-2.434-3.307 2.1 2.1 0 00.882 4.011 2.103 2.103 0 001.552-.704m71.405-33.127a2.097 2.097 0 10-3.614-.932 2.099 2.099 0 002.077 1.637 2.107 2.107 0 001.552-.705"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3088F4",
    fillRule: "nonzero",
    stroke: "#3088F4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M192.167 101.596a2.1 2.1 0 00-2.435-3.307 2.1 2.1 0 102.435 3.307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M50.582 89.189a2.1 2.1 0 00-2.435-3.307 2.1 2.1 0 00.883 4.011 2.104 2.104 0 001.552-.704"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4FF6",
    fillRule: "nonzero",
    stroke: "#4C4FF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M270.251 68.841c.45-.483.643-1.152.52-1.801a2.111 2.111 0 00-4.188.323 2.115 2.115 0 001.824 2.158 2.075 2.075 0 001.844-.685"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M260.651 12.186c.45-.481.644-1.149.52-1.796a2.113 2.113 0 10-2.369 2.481 2.074 2.074 0 001.85-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3088F4",
    fillRule: "nonzero",
    stroke: "#3088F4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M266.106 22.112c.45-.482.643-1.15.52-1.797a2.111 2.111 0 00-4.188.321 2.114 2.114 0 001.818 2.16 2.067 2.067 0 001.85-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M272.056 22.112c.45-.482.644-1.15.52-1.797a2.11 2.11 0 00-4.187.321 2.113 2.113 0 001.818 2.16 2.07 2.07 0 001.85-.69m-17.357-9.92a2.06 2.06 0 00.521-1.796 2.112 2.112 0 00-4.187.32 2.115 2.115 0 001.817 2.161 2.072 2.072 0 001.85-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4FF6",
    fillRule: "nonzero",
    stroke: "#4C4FF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M266.602 12.186c.45-.481.643-1.149.52-1.796a2.111 2.111 0 00-4.188.32 2.115 2.115 0 001.818 2.161 2.073 2.073 0 001.85-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M272.552 12.186c.45-.481.644-1.149.52-1.796a2.112 2.112 0 00-4.187.32 2.115 2.115 0 001.817 2.161 2.072 2.072 0 001.85-.69m2.975 4.968c.45-.481.644-1.149.52-1.797a2.113 2.113 0 00-4.187.322 2.114 2.114 0 001.818 2.16 2.074 2.074 0 001.85-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4FF6",
    fillRule: "nonzero",
    stroke: "#4C4FF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M269.577 17.149c.45-.481.644-1.149.52-1.797a2.113 2.113 0 00-4.187.322 2.114 2.114 0 001.817 2.16 2.072 2.072 0 001.85-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M58.228 13.73L36.906 47.506a4.78 4.78 0 01-8.113 0L7.441 13.73a4.89 4.89 0 01-.183-4.95 4.88 4.88 0 014.235-2.564h42.644a4.878 4.878 0 014.265 2.547 4.89 4.89 0 01-.174 4.967z",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M59.383 13.303L37.228 48.385a4.957 4.957 0 01-8.43 0L6.653 13.303a5.077 5.077 0 01-.188-5.14 5.068 5.068 0 014.398-2.662h44.306a5.074 5.074 0 014.214 7.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31.243 31.045a2.07 2.07 0 00.496-1.797 2.112 2.112 0 00-4.188.324 2.113 2.113 0 001.823 2.158 2.069 2.069 0 001.869-.685"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4FF6",
    fillRule: "nonzero",
    stroke: "#4C4FF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.293 31.045c.44-.486.625-1.153.495-1.797a2.113 2.113 0 10-2.365 2.482 2.07 2.07 0 001.87-.685m12.397 0c.44-.486.625-1.153.495-1.797a2.111 2.111 0 00-4.188.324 2.115 2.115 0 001.823 2.158 2.071 2.071 0 001.87-.685"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28.764 36.504a2.07 2.07 0 00.496-1.797 2.112 2.112 0 00-4.189.324 2.115 2.115 0 001.823 2.158 2.07 2.07 0 001.87-.685"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4FF6",
    fillRule: "nonzero",
    stroke: "#4C4FF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M34.714 36.504a2.07 2.07 0 00.496-1.797 2.112 2.112 0 00-4.188.324 2.113 2.113 0 001.823 2.158 2.069 2.069 0 001.869-.685m-2.975 5.459a2.07 2.07 0 00.496-1.797 2.112 2.112 0 00-4.188.324 2.113 2.113 0 001.822 2.158 2.07 2.07 0 001.87-.685"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M43.64 31.045a2.07 2.07 0 00.496-1.797 2.112 2.112 0 00-4.189.324 2.115 2.115 0 001.823 2.158 2.07 2.07 0 001.87-.685m-2.976 5.459a2.063 2.063 0 00.496-1.797 2.113 2.113 0 10-2.365 2.482 2.07 2.07 0 001.87-.685"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4FF6",
    fillRule: "nonzero",
    stroke: "#4C4FF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M263.13 17.149c.45-.481.644-1.149.521-1.797a2.114 2.114 0 10-2.37 2.482 2.074 2.074 0 001.85-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M34.714 47.174a2.07 2.07 0 00.496-1.797 2.112 2.112 0 00-4.188.324 2.113 2.113 0 001.823 2.158 2.069 2.069 0 001.869-.685m3.471-5.211a2.066 2.066 0 00.496-1.797 2.112 2.112 0 00-4.188.324 2.114 2.114 0 001.823 2.158 2.071 2.071 0 001.87-.685"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M177.569 13.73l-21.323 33.776a4.77 4.77 0 01-8.107 0L126.817 13.73a4.884 4.884 0 014.056-7.514h42.644a4.88 4.88 0 014.235 2.564 4.89 4.89 0 01-.183 4.95z",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M178.07 13.303l-22.156 35.082a4.957 4.957 0 01-8.43 0L125.33 13.303a5.08 5.08 0 01-.187-5.143 5.07 5.07 0 014.402-2.659h44.306a5.069 5.069 0 014.405 2.657 5.075 5.075 0 01-.186 5.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4FF6",
    fillRule: "nonzero",
    stroke: "#4C4FF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M153.405 46.628c.354-.382.552-.883.555-1.405a2.113 2.113 0 10-2.112 2.114 2.072 2.072 0 001.557-.71m-3.472-5.453c.45-.481.644-1.149.52-1.797a2.113 2.113 0 10-2.365 2.482 2.07 2.07 0 001.845-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M156.875 41.174c.45-.481.644-1.149.52-1.797a2.11 2.11 0 00-4.187.324 2.113 2.113 0 001.822 2.158 2.07 2.07 0 001.845-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M296.383 13.73l-21.322 33.776a4.773 4.773 0 01-8.107 0L245.63 13.73a4.889 4.889 0 01-.182-4.952 4.88 4.88 0 014.239-2.562h42.644a4.88 4.88 0 014.235 2.564 4.888 4.888 0 01-.184 4.95z",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M297.187 13.303l-22.15 35.082a4.956 4.956 0 01-8.43 0l-22.14-35.082a5.075 5.075 0 01-.189-5.14 5.07 5.07 0 014.398-2.662h44.306a5.069 5.069 0 014.394 2.664c.873 1.62.8 3.586-.19 5.138z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4FF6",
    fillRule: "nonzero",
    stroke: "#4C4FF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M276.38 41.67c.45-.482.643-1.15.52-1.797a2.113 2.113 0 10-2.371 2.481 2.07 2.07 0 001.85-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M268.445 41.67c.45-.482.644-1.15.52-1.797a2.11 2.11 0 00-4.187.321 2.114 2.114 0 001.818 2.16 2.072 2.072 0 001.85-.69m-2.976-5.949c.45-.482.644-1.15.52-1.797a2.112 2.112 0 00-4.187.324 2.113 2.113 0 001.822 2.158 2.07 2.07 0 001.845-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4FF6",
    fillRule: "nonzero",
    stroke: "#4C4FF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M272.908 35.715c.45-.482.644-1.15.52-1.797a2.112 2.112 0 00-4.187.324 2.113 2.113 0 001.822 2.158 2.07 2.07 0 001.845-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    stroke: "#00D0B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M279.85 35.715c.453-.48.646-1.149.52-1.797a2.11 2.11 0 00-2.238-1.72 2.114 2.114 0 00-.126 4.202 2.061 2.061 0 001.844-.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3088F4",
    fillRule: "nonzero",
    stroke: "#3088F4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M272.412 47.128a2.06 2.06 0 00.52-1.796 2.11 2.11 0 00-4.187.321 2.114 2.114 0 001.818 2.16 2.072 2.072 0 001.85-.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCE0F8",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M198.688 134.132a3.312 3.312 0 106.247.241 3.31 3.31 0 00-3.163-2.34 2.23 2.23 0 00-.327 0h-.105a3.218 3.218 0 00-2.623 1.984M79.456 44.31c-.15.386-.226.797-.228 1.211a3.315 3.315 0 002.041 3.066c1.238.515 2.664.233 3.612-.715a3.316 3.316 0 00-2.34-5.661h-.432a3.214 3.214 0 00-2.623 1.985M39.127 158.454a.719.719 0 00-.595 1.112l3.159 4.997.025.04a.887.887 0 001.487 0l3.01-4.76a.893.893 0 000-.922.876.876 0 00-.778-.467h-6.308 0zM215.567.022a.72.72 0 00-.596 1.112l3.16 5.012.024.04a.888.888 0 001.488 0l3.005-4.76a.902.902 0 00-.749-1.389h-6.347l.015-.015z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCE0F8",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M84.955 45.486h-1.983a.715.715 0 00-.71.715v5.216a.907.907 0 00.908.908h5.013a.908.908 0 00.908-.908v-5.022a.914.914 0 00-.908-.909h-3.228zm173.207 96.74h-1.983a.71.71 0 00-.71.71v5.215a.907.907 0 00.897.923h5.01a.913.913 0 00.912-.908v-5.047a.913.913 0 00-.913-.908l-3.213.015zm-151.443-3.648v5.499m-2.747-2.749h5.494m115.027-96.149v5.503m-2.753-2.754h5.5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.415,
    cy: 134.017,
    fill: "#CCE0F8",
    fillRule: "nonzero",
    rx: 1.175,
    ry: 1.176
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.668,
    cy: 60.29,
    fill: "#CCE0F8",
    fillRule: "nonzero",
    rx: 1.175,
    ry: 1.176
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.81,
    height: 23.95,
    x: 116.631,
    y: 153.05,
    fill: "#3088F4",
    fillRule: "nonzero",
    rx: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.81,
    height: 23.95,
    x: 0.119,
    y: 0.263,
    fill: "#3088F4",
    fillRule: "nonzero",
    rx: 3.79,
    transform: "translate(116.512 152.787)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#benchmarks_market_share_empty_state_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#benchmarks_market_share_empty_state_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00D0B2",
    fillRule: "nonzero",
    d: "M138.514 99.511v1.688c0 .769 2.445 1.652 2.445 1.652.21.768.515 1.506.907 2.199 0 0-1.1 2.357-.56 2.898l1.195 1.196c.54.54 2.896-.566 2.896-.566a9.209 9.209 0 002.191.908s.883 2.452 1.652 2.452h1.686c.768 0 1.65-2.452 1.65-2.452a9.403 9.403 0 002.198-.908s2.355 1.107 2.895.566l1.195-1.196c.541-.541-.565-2.898-.565-2.898.396-.69.701-1.43.908-2.199 0 0 2.45-.883 2.45-1.652V99.51a1.39 1.39 0 00-1.389-1.389l-1.061-.263a9.296 9.296 0 00-.908-2.194s1.106-2.357.565-2.903l-1.195-1.191c-.54-.541-2.895.565-2.895.565a9.471 9.471 0 00-2.197-.913s-.883-2.446-1.651-2.446h-1.666c-.77 0-1.652 2.446-1.652 2.446a9.496 9.496 0 00-2.191.913s-2.356-1.106-2.896-.565l-1.195 1.19c-.54.547.565 2.904.565 2.904a9.472 9.472 0 00-.912 2.194s-2.465.883-2.465 1.652z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3543",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M137.944 99.397v1.916c0 .873 2.777 1.876 2.777 1.876.236.868.582 1.702 1.031 2.481 0 0-1.254 2.675-.64 3.29l1.354 1.35c.615.62 3.288-.635 3.288-.635.78.446 1.613.793 2.48 1.032 0 0 .99 2.774 1.868 2.774h1.915c.872 0 1.874-2.774 1.874-2.774.866-.24 1.698-.587 2.48-1.032 0 0 2.672 1.256 3.287.635l1.354-1.35c.614-.615-.64-3.29-.64-3.29.444-.781.79-1.615 1.031-2.481 0 0 2.772-.993 2.772-1.876v-1.916a1.572 1.572 0 00-1.572-1.573l-1.2-.298c-.239-.867-.585-1.7-1.031-2.481 0 0 1.254-2.675.64-3.29l-1.34-1.365c-.614-.616-3.287.64-3.287.64a10.924 10.924 0 00-2.48-1.032s-.99-2.78-1.874-2.78h-1.914c-.867 0-1.87 2.78-1.87 2.78-.866.237-1.7.584-2.478 1.032 0 0-2.673-1.256-3.288-.64l-1.354 1.354c-.615.616.64 3.29.64 3.29-.448.78-.794 1.615-1.031 2.482 0 0-2.792 1.013-2.792 1.881z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.069,
    cy: 100.355,
    stroke: "#2C3543",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 3.759,
    ry: 3.762
  }))));
}
export default SvgBenchmarksMarketShareEmptyState;